import { SettingsAccountInfoScreenContainer } from "src/containers";

export const SettingsAccountInfoScreen = () => (
  <SettingsAccountInfoScreenContainer />
);
